export const CLASS_NAMES = {
  heading: 'text-style-h-em text-neutral-700 md:text-style-f-em',
};

export const NO_CUSTOMER_TEXT = 'No customer added...';

export const DESCRIPTION = 'Customer';
